import { gql } from "config/graphql";
import {
  Camelize,
  IAccessToken,
  MutationResponse,
  PhoneVerificationMode,
  SessionStatusesStrings,
  SuccessResponse,
} from "config/types";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

interface IExchangeLoginTokenData {
  exchangeLoginToken: {
    token: Camelize<IAccessToken>;
  };
}

export const exchangeLoginTokenMutation: MutationResponse<
  { loginToken: string },
  IExchangeLoginTokenData
> = async (input: { loginToken: string }) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation exchangeLoginToken($input: ExchangeLoginTokenInput!) {
      exchangeLoginToken(input: $input) {
        token {
          accessToken
          createdAt
          expiresIn
          refreshToken
          scope
          tokenType
        }
      }
    }
  `;

  const { data } = await client.mutate<IExchangeLoginTokenData>({
    variables: { input },
    mutation,
  });
  return { data: assertDefined(data) };
};

interface IVerifySessionData {
  verifySession: {
    session: {
      status: SessionStatusesStrings;
    };
  };
}

export const verifySessionMutation: MutationResponse<
  { code: string; phoneNumberId?: string },
  IVerifySessionData
> = async (input: { code: string; phoneNumberId?: string }) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation verifySession($input: VerifySessionInput!) {
      verifySession(input: $input) {
        session {
          id
          status
        }
      }
    }
  `;

  const { data } = await client.mutate<IVerifySessionData>({
    variables: { input },
    mutation,
  });
  return { data: assertDefined(data) };
};

interface IRequestOtpData {
  requestOtp: SuccessResponse;
}

export const requestOtpMutation: MutationResponse<
  { sessionId: string; phoneNumberId?: string; channel?: PhoneVerificationMode },
  IRequestOtpData
> = async (input: {
  sessionId: string;
  phoneNumberId?: string;
  channel?: PhoneVerificationMode;
}) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation requestOtp($input: RequestOtpInput!) {
      requestOtp(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IRequestOtpData>({
    variables: { input },
    mutation,
  });
  return { data: assertDefined(data) };
};
